module.exports = {"350602001":"东铺头街道","350602002":"西桥街道","350602003":"新桥街道","350602004":"巷口街道","350602005":"南坑街道","350602006":"通北街道","350602007":"芝山街道","350602008":"石亭街道","350602100":"浦南镇","350602101":"天宝镇","350602400":"芗城区奶牛场","350602402":"天宝林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350602.json
// module id = 1319
// module chunks = 0